import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'element-plus/dist/index.css';

import App from './App.vue';
import router from './router';
import { registerDirectives } from './directives/permission';
import { reportError } from '@/utils/errorReport';

// 全局未捕获错误上报
window.addEventListener('error', (event) => {
  const msg = event.message || 'Unknown error';
  const stack = event.error?.stack || '';
  console.error(`[WindowError] ${msg} at ${event.filename}:${event.lineno}:${event.colno}`, event.error);
  reportError({
    level: 'error',
    type: 'window_error',
    message: msg,
    stack,
    url: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : window.location.href,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = reason?.message || String(reason) || 'Unhandled promise rejection';
  const stack = reason?.stack || '';
  console.error(`[UnhandledRejection] ${msg}`, reason, stack);
  reportError({
    level: 'error',
    type: 'unhandledrejection',
    message: msg,
    stack,
    url: window.location.href,
    extra: { reason: String(reason) },
  });
});

async function bootstrap() {
  const pinia = createPinia();
  const app = createApp(App);
  app.use(pinia);
  app.use(router);

  // Vue 组件错误上报
  app.config.errorHandler = (err, _instance, info) => {
    const msg = err instanceof Error ? err.message : String(err);
    const stack = err instanceof Error ? err.stack || '' : '';
    console.error(`[VueError] ${msg} info=${info}`, err);
    reportError({
      level: 'error',
      type: 'vue_error',
      message: msg,
      stack,
      url: window.location.href,
      extra: { info },
    });
  };

  // 路由错误上报
  router.onError((err) => {
    reportError({
      level: 'error',
      type: 'router_error',
      message: err instanceof Error ? err.message : String(err),
      stack: err instanceof Error ? err.stack || '' : '',
      url: window.location.href,
    });
  });

  try {
    const { useAuthStore } = await import('@/stores/auth');
    const auth = useAuthStore();
    await auth.fetchMe();
    auth.fetchMeAttempted = true;
  } catch (e) {
    console.error('[Bootstrap] fetchMe failed', e);
    reportError({
      level: 'error',
      type: 'bootstrap',
      message: e instanceof Error ? e.message : String(e),
      stack: e instanceof Error ? e.stack || '' : '',
      url: window.location.href,
    });
  }

  registerDirectives(app);
  app.mount('#app');
}

bootstrap().catch((err) => {
  console.error('[Bootstrap] fatal', err);
  reportError({
    level: 'error',
    type: 'bootstrap_fatal',
    message: err instanceof Error ? err.message : String(err),
    stack: err instanceof Error ? err.stack || '' : '',
    url: window.location.href,
  });
});
